import React, { useState } from 'react';
import { useCSS } from '../../../lib/hooks.js';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../../lib/ep.js';

import ActionButton from '../../builder/ActionButton';
import ActionLink from '../../builder/ActionLink';

import FloatingLayerPublic from '../../front/FloatingLayerPublic';
import QuizStats from '../../front/quiz/QuizStats';

const ButtonQuizStats = (props) => {
	const promotion = props?.promotion.Promotion ?? false;

	useCSS('comp/quiz.css');

	const [ open, setOpen ] = useState(false);
	if(promotion === false) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const toggle = () => {
		setOpen(!open);
	};

	const type = props?.type ?? 'button';
	const ComponentType = (type == 'link') ? ActionLink : ActionButton;

	return (
		<span class="quiz_stats_btn gui_is_not_padded">
			<ComponentType
				onClick={toggle}
				_fullclass='see_quiz_stats quiz_stats'
				autotranslate={false}
			>{promotion?.quiz_stats_link ?? i18n("View statistics")}</ComponentType>

			{(open) && (
				<FloatingLayerPublic
					backButton={toggle}
					//title={`<h1>${i18n("Quiz statistics")}</h1>`}
					//full_content={true}
				>
					<QuizStats
						promotion_id={promotion.id}
						builder={false}
					/>
				</FloatingLayerPublic>
			)}
		</span>
	)
}

export default injectIntl(ButtonQuizStats);